export default __webpack_public_path__ + "static/media/abe-o.40d922f8.png";